import React from 'react';
import styles from './LunchPageFilters.module.scss';
import DietFilterBadge from './DietFilterBadge';
import RestaurantFilterBadge from './RestaurantFilterBadge';

const LunchPageFilters: React.FunctionComponent = () => {
  return (
    <div className={styles.component}>
      <DietFilterBadge />
      <RestaurantFilterBadge />
    </div>
  );
};

export default LunchPageFilters;
